export enum totalApprovedTotalAllocationRatio {
  ratio = 0.01,
}
